import { render, staticRenderFns } from "./jydd.vue?vue&type=template&id=1769dbf6&scoped=true"
import script from "./jydd.vue?vue&type=script&lang=js"
export * from "./jydd.vue?vue&type=script&lang=js"
import style0 from "./jydd.vue?vue&type=style&index=0&id=1769dbf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1769dbf6",
  null
  
)

export default component.exports